module.exports = __webpack_public_path__ + "img/37.557ccb02.png";